import { c as _c } from "react/compiler-runtime";
import { CONTACT_API } from 'modules/contacts/api/contact-api';
import { ContactPageSwrInterface } from 'modules/contacts/contact-page/types/contact-page-filter-interface';
import { ContactSurveysApiInterface } from 'modules/contacts/contact-page/types/contact-surveys-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
export function useContactSurveys(t0) {
  const $ = _c(11);
  const {
    limit,
    pagination,
    filter,
    contactId,
    shouldFetch
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  const filterApi = `${filter.date[0] ? `&filter[dateSince]=${filter.date[0]}` : ""}${filter.date[1] ? `&filter[dateTill]=${filter.date[1]}` : ""}`;
  let t2;
  if ($[1] !== contactId || $[2] !== filterApi || $[3] !== limit || $[4] !== pagination || $[5] !== shouldFetch || $[6] !== user) {
    t2 = () => {
      if (user && shouldFetch && pagination.startFromId === undefined && limit) {
        return `${CONTACT_API}/contacts/${contactId}/surveys?pagination[limit]=${limit}${filterApi}`;
      } else {
        if (user && shouldFetch && pagination.startFromId && limit) {
          return `${CONTACT_API}/contacts/${contactId}/surveys?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}${filterApi}`;
        }
      }
      return null;
    };
    $[1] = contactId;
    $[2] = filterApi;
    $[3] = limit;
    $[4] = pagination;
    $[5] = shouldFetch;
    $[6] = user;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const {
    data: contactSurveys,
    mutate
  } = useSWR(t2, fetcher);
  let t3;
  if ($[8] !== contactSurveys || $[9] !== mutate) {
    t3 = {
      contactSurveys,
      mutate
    };
    $[8] = contactSurveys;
    $[9] = mutate;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}